import React from 'react';
import classes from './ReportsTableHeader.module.css';
import filterIcon from '../../../assets/icons/filter-icon.svg';
import CustomDropdown from '../../UI/Inputs/CustomDropdown';
import closeIcon from '../../../assets/icons/close.svg';
import { DropDown } from '../../UI/DropDown';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  filterByStatus?: number;
  setFilterByStatus?: (status?: number) => void;
  filterByService?: number;
  setFilterByService?: (status?: number) => void;
  serviceTypes?: { service_id: number; service_name: string }[];
  statusTypes?: { id: number; label: string }[];
};

const Filters: React.FC<Props> = ({
  filterByStatus,
  setFilterByStatus,
  filterByService,
  setFilterByService,
  serviceTypes,
  statusTypes,
}) => {
  const { translations } = useTranslation();
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <DropDown
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      Toggle={() => (
        <img
          alt={'filter'}
          src={filterIcon}
          className={classes.filterIcon}
          onClick={() => setIsOpen(true)}
        />
      )}
    >
      <div className={classes.filterContent}>
        {setFilterByService && (
          <div className={classes.filterItem}>
            <CustomDropdown
              label={translations('filter.by.service')}
              placeholder={translations('service.filter')}
              options={
                serviceTypes
                  ? serviceTypes.map((service) => ({
                      id: service.service_id,
                      label: service.service_name,
                    }))
                  : []
              }
              value={filterByService}
              onChange={(event) => setFilterByService(parseInt(event.target.value))}
              maxWidth={'220px'}
            />
            {filterByService && (
              <img
                alt={'remove'}
                className={classes.removeIcon}
                src={closeIcon}
                onClick={() => setFilterByService(undefined)}
              />
            )}
          </div>
        )}
        {setFilterByStatus && (
          <div className={classes.filterItem}>
            <CustomDropdown
              label={translations('filter.by.status')}
              placeholder={translations('status.filter')}
              options={statusTypes ?? []}
              value={filterByStatus?.toString()}
              onChange={(event) => setFilterByStatus(parseInt(event.target.value))}
              maxWidth={'250px'}
            />
            {filterByStatus && (
              <img
                alt={'remove'}
                className={classes.removeIcon}
                src={closeIcon}
                onClick={() => setFilterByStatus(undefined)}
              />
            )}
          </div>
        )}
      </div>
    </DropDown>
  );
};

export { Filters };
